/* eslint-disable no-nested-ternary */
import React from 'react';
import classNames from 'classnames';
import LoadingSpinner from '../../../../components/spinner/LoadingSpinner';
import ConfirmationModal from '../../../../components/modals/ConfirmationModalNew';

const LocationsStatusUpdateConfirmation = ({
	loading,
	onCancel,
	handleStatusChangeAction,
	selectedAction,
	locations,
	upcomingShiftsCount,
	origin = 'LOCATIONS',
	professionalName
}) => {
	const actionLabel = selectedAction === 'ENABLE' ? 'Enable' : 'Disable';
	const locationsCount = locations.length;
	const title =
		locationsCount > 1
			? `${actionLabel} professional at selected locations?`
			: `${actionLabel} professional at this location?`;
	const updateConfirmLabel =
		origin === 'LOCATIONS'
			? locationsCount > 1
				? `${actionLabel} at (${locationsCount}) selected locations`
				: `${actionLabel} at this location`
			: `${actionLabel} professional`;

	const getConfirmationText = () => {
		const locationText = locationsCount === 1 ? locations[0].facility_name : 'each selected location';

		if (selectedAction === 'ENABLE') {
			return (
				<div>
					This will set <b>{professionalName}</b> as <b>enabled</b> at {locationText}. Enabled professionals can fill
					shifts at locations where they are enabled. Please make sure you have selected the correct location
					{locationsCount > 1 ? 's' : ''} before continuing.
				</div>
			);
		}
		if (upcomingShiftsCount) {
			return (
				<div>
					This will set <b>{professionalName}</b> as <b>disabled</b> at {locationText}.{' '}
					<b>
						{upcomingShiftsCount} upcoming shift{upcomingShiftsCount > 1 ? 's' : ''} for this professional will be
						cancelled
					</b>{' '}
					and {upcomingShiftsCount === 1 ? 'a' : ''} replacement shift{upcomingShiftsCount > 1 ? 's' : ''} will be
					added.
					<br />
					<br /> Disabled professionals <b>cannot</b> fill shifts at locations where they are disabled. Please make sure
					you have selected the correct location{locationsCount > 1 ? 's' : ''} before continuing.
				</div>
			);
		}
		return (
			<div>
				This will set <b>{professionalName}</b> as <b>disabled</b> at {locationText}. Disabled professionals{' '}
				<b>cannot</b> fill shifts at locations where they are disabled. Please make sure you have selected the correct
				location
				{locationsCount > 1 ? 's' : ''} before continuing.
			</div>
		);
	};

	return (
		<ConfirmationModal
			size="l"
			className={classNames('enable-location-confirmation-modal', { 'is-loading': loading })}
			cancelLabel="Cancel"
			title={title}
			onCancel={onCancel}
			onConfirm={handleStatusChangeAction}
			confirmLabel={updateConfirmLabel}
		>
			{loading ? <LoadingSpinner /> : getConfirmationText()}
		</ConfirmationModal>
	);
};

export default LocationsStatusUpdateConfirmation;
